import { render, staticRenderFns } from "./BackofficeOrcamentoAnexo.vue?vue&type=template&id=c96e735c&scoped=true"
import script from "./BackofficeOrcamentoAnexo.vue?vue&type=script&lang=ts"
export * from "./BackofficeOrcamentoAnexo.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeOrcamentoAnexo.vue?vue&type=style&index=0&id=c96e735c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96e735c",
  null
  
)

export default component.exports